<template>
  <base-modal
    :ref="modal.key"
    :show="open"
    :title="modalTitle"
    @on-confirm="saveItem"
    @on-cancel="hide()"
    :okText="$t('Save')"
    :closeText="$t('Close')"
  >
    <v-form class="mt-5">
      <v-radio-group v-model="restore" row>
        <v-radio v-bind:label="$t('RecoverPassword')" value="password"></v-radio>
        <v-radio v-bind:label="$t('RestoreTwoFactorAuthentication')" value="device"></v-radio>
      </v-radio-group>
      <v-text-field
        v-bind:label="$t('Email')"
        v-model="email"
        maxlength="100"
        :counter="100"
        :error-messages="emailErrors"
        @input="$v.email.$touch()"
        @blur="$v.email.$touch()"
      ></v-text-field>
    </v-form>
  </base-modal>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";

import UserService from "@/services/UserService";

export default {
  name: "RecoverModal",
  data() {
    return {
      modal: {
        title: this.$t("LoginProblems"),
        key: "recoverModal",
      },
      open: false,
      email: "",
      restore: "password",
    };
  },
  mixins: [validationMixin],
  validations: {
    email: { required },
  },
  computed: {
    modalInstance() {
      return this.$refs[this.modal.key];
    },
    modalTitle() {
      return this.modal.title;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.required && errors.push(this.$t("RequiredField"));
      return errors;
    },
  },
  methods: {
    saveItem() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      this.modalInstance.progress(true);
      if (this.restore == "password") {
        UserService.recoverPassword(this.email);
      } else {
        UserService.recoverDevice(this.email);
      }
      this.modalInstance.progress(false);
      this.hide();
    },
    new() {
      this.email = "";
      this.$v.$reset();
      this.show();
    },
    show() {
      this.open = true;
    },
    hide() {
      this.open = false;
    },
  },
};
</script>